import crearApiOrdenesRemito from "./apiOrdenesRemito";

const api = crearApiOrdenesRemito(
  "/ordenpagoremito",
  "proveedor"
);

export const postOrdenPagoRemito = api.crear;

export const getOrdenPagoRemito = api.obtener;

export const listOrdenesPagoRemito = api.listar;

export const getPendientesOrdenPagoRemito = api.pendientes;

export const getCreditosDisponiblesOrdenPagoRemito = api.creditos;

export const anularOrdenPagoRemito = api.anular;

export const putObservacionesOrdenPagoRemito =
  api.actualizarObservaciones;

export default api;